import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VersionNavComponent } from '../../shared/components/version-nav/version-nav.component';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-terms',
  imports: [CommonModule, VersionNavComponent, HeaderComponent],
  templateUrl: './terms.component.html',
  styleUrl: './terms.component.scss'
})
export class TermsComponent implements OnInit {
  currentDate = new Date();
  isAuthenticated = false;

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.isAuthenticated = this.authService.isAuthenticated() && !this.authService.isTokenExpired();
  }
}
